import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  CardText,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { formValidation, mapDataForDropDown } from "helpers/helpers"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllProducts } from "store/products/actions"
import { getAllProductChannels } from "store/channels/actions"
import { getAllProductCategories } from "store/categories/actions"
import { getAllSuppliers } from "store/suppliers/actions"
import { getAllUsers } from "store/users/actions"
import { createOperatorProduct } from "store/operatorProducts/actions"
import { apiError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import {sitename} from "../../../constants/constants";
const Create = props => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllProductChannels())
    dispatch(getAllProducts())
    dispatch(getAllProductCategories())
    dispatch(getAllSuppliers())
    dispatch(apiError(""))
  }, [])

  const Products = useSelector(state => state?.products?.Index ?? [])
  const Channels = useSelector(state => state?.productChannels?.Index ?? [])
  const Categories = useSelector(state => state?.productCategories?.Index ?? [])
  const Suppliers = useSelector(state => state?.suppliers?.Index ?? [])
  const formErrors = useSelector(state => state?.CommonState)

  const [channel, setChannel] = useState("")
  const [category, setCategory] = useState("")
  const [product, setProduct] = useState("")
  const [supplier, setSupplier] = useState("")
  const [isActive, setIsActive] = useState(false)
  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      product_channel_id: channel.id,
      product_category_id: category.id,
      product_id: product.id,
      supplier_id: supplier.id,
      is_active: isActive,
    }
    dispatch(createOperatorProduct(data, props.history))
  }
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Operator Products" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              product details
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Product Channel
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={channel => {
                        removeError("product_channel_id")
                        setChannel(channel)
                      }}
                      options={mapDataForDropDown(Channels)}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                    />

                    {formErrors?.product_channel_id ? (
                      <FieldValidation
                        errorMessage={formErrors?.product_channel_id}
                      />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Category
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={category => {
                        removeError("product_category_id")
                        setCategory(category)
                      }}
                      options={mapDataForDropDown(Categories)}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                    />

                    {formErrors?.product_category_id ? (
                      <FieldValidation
                        errorMessage={formErrors?.product_category_id}
                      />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Supplier
                  </Label>
                  <Col sm={5}>
                    <Select
                      onChange={supplier => {
                        removeError("supplier_id")
                        setSupplier(supplier)
                      }}
                      options={mapDataForDropDown(Suppliers)}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                    />
                    {formErrors?.supplier_id ? (
                      <FieldValidation errorMessage={formErrors?.supplier_id} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Product
                  </Label>
                  <Col sm={5}>
                    <Select
                      maxMenuHeight={150}
                      onChange={product => {
                        removeError("product_id")
                        setProduct(product)
                      }}
                      options={mapDataForDropDown(Products)}
                      classNamePrefix="select2-selection"
                    />
                    {formErrors?.product_id ? (
                      <FieldValidation errorMessage={formErrors?.product_id} />
                    ) : null}
                  </Col>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="defaultCheck1"
                    onChange={() => setIsActive(!isActive)}
                    defaultChecked={isActive}
                  />
                  <label className="form-check-label" htmlFor="defaultCheck1">
                    Is Active?
                  </label>
                </div>
                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/operator-products")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const CreateOperatorProduct = withRouter(Create)
